import { useEffect, useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const AbsenceDialog = ({ target, onClose, onConfirm }) => {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  useEffect(() => {
    if (target) {
      setStart(target.day.iso);
      setEnd(target.day.iso);
    }
  }, [target]);

  const invalid = !start || !end || end < start;
  const onStart = (v) => {
    setStart(v);
    if (end < v) setEnd(v);
  };

  return (
    <AlertDialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="absence-dialog" className="w-[calc(100%-2rem)] rounded-2xl sm:w-full">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">Segna assente</AlertDialogTitle>
          <AlertDialogDescription>
            <strong>{target?.employee.name}</strong> risulterà assente nei giorni scelti (domeniche escluse). Le attività da fare di quei giorni passeranno in "Da assegnare".
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label className="text-xs font-medium text-slate-600">Dal</Label>
            <Input data-testid="absence-start-input" type="date" value={start} onChange={(e) => onStart(e.target.value)} className="h-11 rounded-xl" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-medium text-slate-600">Al (compreso)</Label>
            <Input data-testid="absence-end-input" type="date" min={start} value={end} onChange={(e) => setEnd(e.target.value)} className="h-11 rounded-xl" />
          </div>
        </div>
        {end && start && end < start && <p data-testid="absence-range-error" className="text-sm text-rose-600">La data di fine è prima di quella di inizio.</p>}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="absence-cancel-btn" className="rounded-xl">Annulla</AlertDialogCancel>
          <AlertDialogAction data-testid="absence-confirm-btn" disabled={invalid} className="rounded-xl" onClick={() => onConfirm(target, start, end)}>
            Segna assente
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
